<template>
  <div class="mine index" :class="userInfo.type === 3 ? 'organIndex' : ''">
    <!-- 头部背景 -->
    <img
      src="http://img.wish.hebyun.com.cn/images/mine_bg.png"
      class="bg"
      v-if="userInfo.type !== 3"
    />
    <div class="bg bgjg" v-if="userInfo.type == 3"></div>

    <div class="header">
      <!-- 头像 -->
      <div class="header_avatar">
        <img :src="userInfo.avatar" class="header_avatar_img" />
        <img
          src="http://img.wish.hebyun.com.cn/images/party.png"
          class="header_avatar_party"
          v-if="userInfo.type === 2"
        />
        <img
          src="http://img.wish.hebyun.com.cn/images/organ.png"
          class="header_avatar_party"
          v-if="userInfo.type === 3"
        />
      </div>
      <!-- 左侧 -->
      <div class="header_infos">
        <div class="header_names">
          <span>{{ userInfo.nick }}</span>
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_edit.png"
            @click="editInfo"
            v-if="userInfo.type === 1 || userInfo.type === 2"
          />
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_edit_03.png"
            @click="editInfo"
            v-if="userInfo.type === 3"
          />
          <div
            class="register_btn"
            v-if="userInfo.type === 1"
            @click="registerParty"
          >
            认证党员
          </div>
        </div>
        <div class="header_adds">
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_add.png"
            v-if="userInfo.type === 1 || userInfo.type === 2"
          />
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_add_03.png"
            v-if="userInfo.type === 3"
          />
          <span v-if="userInfo.city"
            >{{ userInfo.city }}·{{ userInfo.area }}</span
          >
          <span v-if="userInfo.city == null">暂无地区</span>
        </div>
      </div>
      <!-- 右侧-->
      <div class="header_btns">
        <div class="points" v-if="userInfo.type === 3">
          <img
            src="http://img.wish.hebyun.com.cn/images/footer_thumb_03.png"
            alt=""
          />
          <span> {{ numObj.points }}</span>
        </div>
        <div class="private_btn" @click="jumpPrivate">
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_msg.png"
            alt=""
            v-if="userInfo.type === 1 || userInfo.type === 2"
          />
          <img
            src="http://img.wish.hebyun.com.cn/images/mine_msg_03.png"
            alt=""
            v-if="userInfo.type === 3"
          />

          <!-- <div class="red" v-if="numObj.letter_count !== 0">
            {{ numObj.letter_count > 99 ? "99+" : numObj.letter_count }}
          </div> -->
          <van-badge
            :content="numObj.letter_count"
            max="99"
            v-if="numObj.letter_count !== 0"
          >
            <div class="child" />
          </van-badge>
        </div>
        <div class="login_btn" v-if="userInfo.type !== 3" @click="loginParty">
          单位登录
        </div>
      </div>
    </div>

    <div class="tabs">
      <div class="tabs_header">
        <div
          class="tab tab1"
          :class="tab === '已认领心愿' ? 'active' : ''"
          style="position: relative"
          v-if="userInfo.type !== 1"
          @click="toggleTab('已认领心愿')"
        >
          已认领心愿
        </div>
        <div
          class="tab"
          v-if="userInfo.type !== 3"
          :class="tab === '我的心愿' ? 'active' : ''"
          @click="toggleTab('我的心愿')"
        >
          我的心愿
        </div>

        <div
          class="tab"
          v-if="userInfo.type === 3"
          :class="tab === '待认领心愿' ? 'active' : ''"
          @click="toggleTab('待认领心愿')"
        >
          待认领心愿
          <van-badge
            :content="numObj.wait_confrim_wish_count"
            max="99"
            v-if="numObj.wait_confrim_wish_count !== 0"
          >
            <div class="child" />
          </van-badge>
        </div>
      </div>

      <van-pull-refresh
        v-model="isDownLoading"
        @refresh="onRefresh"
        v-if="tab === '已认领心愿'"
      >
        <van-list
          v-model="vantList_IsLoading"
          :finished="vantList_IsLoadOver"
          offset="20"
          :finished-text="'我是有底线的'"
          :finish-text="'数据加载完毕'"
          :loading-text="'数据加载中...'"
          @load="onUpRefreshLoad"
          v-if="claimWishList.length > 0"
        >
          <!-- 已认领心愿 -->
          <div class="tabs_content">
            <MyWish :list="claimWishList" :state="0" :userInfo="userInfo" />
          </div>
        </van-list>
        <!-- 已认领心愿空状态 -->
        <div class="tabs_content" v-if="claimWishList.length === 0">
          <div class="wish">
            <van-empty
              class="custom-image"
              description="暂无相关心愿"
              image="http://img.wish.hebyun.com.cn/images/empty_state.png"
            />
          </div>
        </div>
      </van-pull-refresh>

      <!-- 我的心愿 -->
      <van-pull-refresh
        v-model="isDownLoading"
        @refresh="onRefresh"
        v-if="tab === '我的心愿'"
      >
        <van-list
          v-model="vantList_IsLoading"
          :finished="vantList_IsLoadOver"
          offset="20"
          :finished-text="'我是有底线的'"
          :finish-text="'数据加载完毕'"
          :loading-text="'数据加载中...'"
          @load="onUpRefreshLoad"
          v-if="wishList.length > 0"
        >
          <div class="tabs_content">
            <MyWish :list="wishList" :state="1" :userInfo="userInfo" />
          </div>
        </van-list>
        <!-- 我的心愿空状态 -->
        <div class="tabs_content" v-if="wishList.length === 0">
          <div class="wish">
            <van-empty
              class="custom-image"
              description="暂无相关心愿"
              image="http://img.wish.hebyun.com.cn/images/empty_state.png"
            />
          </div>
        </div>
      </van-pull-refresh>

      <van-pull-refresh
        v-model="isDownLoading"
        @refresh="onRefresh"
        v-if="tab === '待认领心愿'"
      >
        <van-list
          v-model="vantList_IsLoading"
          :finished="vantList_IsLoadOver"
          offset="20"
          :finished-text="'我是有底线的'"
          :finish-text="'数据加载完毕'"
          :loading-text="'数据加载中...'"
          @load="onUpRefreshLoad"
          v-if="wishConfirmList.length > 0"
        >
          <!-- 待认领心愿 -->
          <div class="tabs_content">
            <Wish :list="wishConfirmList" :state="2" @refresh="refresh" />
          </div>
        </van-list>
        <!-- 待认领心愿空状态 -->
        <div class="tabs_content" v-if="wishConfirmList.length === 0">
          <div class="wish">
            <van-empty
              class="custom-image"
              description="暂无相关心愿"
              image="http://img.wish.hebyun.com.cn/images/empty_state.png"
            />
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <!-- 评价弹窗 -->

    <van-popup v-model="showpj" round>
      <MyComment />
    </van-popup>
  </div>
</template>

<script>
import MyWish from "@/components/MyWish";
import Wish from "@/components/Wish";
import MyComment from "@/toast/MyComment";

export default {
  name: "mine",
  components: {
    MyWish,
    Wish,
    MyComment,
    // SlideBar,
  },
  data() {
    return {
      tab: "",
      numObj: {}, //查询用户个人中心（个人、党员、机构）数据
      wishList: [], //我的心愿数据
      wishConfirmList: [], //待认领心愿
      claimWishList: [], //已认领心愿
      url: "/wish/pager_user_list", // 当前用户发布的心愿
      url1: "/wish_claim/pager_wait_confirm_wishlist", //待认领心愿
      url2: "/wish_claim/pager_claim_wish", //党员或单位的认领心愿
      page: 1,
      limit: 10,
      userInfo: {}, //用户信息
      showpj: false,
      isDownLoading: false, // 下拉刷新
      vantList_IsLoading: false,
      vantList_IsLoadOver: false,
      data_lengthShow: true,
      uid: "",
      isFirstPage: false,
    };
  },
  created() {
    this.uid = localStorage.getItem("uid");
    this.queryNum();
    this.queryUserInfo();
    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 查询用户个人中心（个人、党员、机构）数据
    async queryNum() {
      let { data } = await this.$api.queryMine();
      this.numObj = data;
    },

    // 查询当前用户发布的心愿列表
    async queryWishList() {
      let { page, limit, url } = this;
      url +=
        `${url.indexOf("?") >= 0 ? "&" : "?"}page=${page}&limit=${limit}` +
        "&uid=" +
        this.uid;
      let { data } = await this.$api.request(url);
      if (this.page == 1) {
        this.wishList = data;
      } else {
        this.wishList = this.wishList.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },

    // 查询待认领心愿
    async queryWishConfirmList() {
      let { page, limit, url1 } = this;
      url1 +=
        `${url1.indexOf("?") >= 0 ? "&" : "?"}page=${page}&limit=${limit}` +
        "&uid=" +
        this.uid;
      let { data } = await this.$api.request(url1);
      data.forEach((item) => {
        item.is_thumb = 0;
      });
      this.wishConfirmList = data;
      if (this.page == 1) {
        this.wishConfirmList = data;
      } else {
        this.wishConfirmList = this.wishConfirmList.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },

    // 查询党员或单位的已认领心愿
    async queryClaimWish() {
      let { page, limit, url2 } = this;
      url2 +=
        `${url2.indexOf("?") >= 0 ? "&" : "?"}page=${page}&limit=${limit}` +
        "&uid=" +
        this.uid;
      let { data } = await this.$api.request(url2);

      data.forEach((item) => {
        item.is_thumb = 0;
      });
      this.claimWishList = data;
      if (this.page == 1) {
        this.claimWishList = data;
      } else {
        this.claimWishList = this.claimWishList.concat(data);
      }
      this.vantList_IsLoading = false;
      if (data.length < this.limit) {
        this.vantList_IsLoadOver = true;
      } else {
        this.vantList_IsLoadOver = false;
        this.page = this.page + 1;
      }
    },

    // 点击编辑图标
    editInfo() {
      this.$router.push("./edit");
    },

    //查询用户信息
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      this.userInfo = data;
      if (this.userInfo.type === 1) {
        this.tab = "我的心愿";
        this.queryWishList(1);
      } else if (this.userInfo.type === 2 || this.userInfo.type === 3) {
        this.tab = "已认领心愿";
        this.queryClaimWish(1);
      }
    },

    // 认证党员
    registerParty() {
      this.$router.push("./register");
    },
    // 单位登录
    loginParty() {
      this.$router.push("./login");
    },
    // 跳转私信列表
    jumpPrivate() {
      this.$router.push("./myprivate");
    },

    // 点击tab
    toggleTab(e) {
      this.tab = e;
      this.page = 1;
      if (e === "待认领心愿") {
        this.queryWishConfirmList();
      } else if (e === "我的心愿") {
        this.queryWishList();
      } else if (e === "已认领心愿") {
        this.queryClaimWish();
      }
    },

    // 刷新页面
    refresh() {
      this.queryNum();
      this.page = 1;
      this.wishConfirmList = [];
      this.queryWishConfirmList();
    },

    // 下拉加载
    onRefresh() {
      this.page = 1;
      if (this.tab === "待认领心愿") {
        this.queryWishConfirmList();
      } else if (this.tab === "我的心愿") {
        this.queryWishList();
      } else if (this.tab === "已认领心愿") {
        this.queryClaimWish();
      }
      this.$toast("刷新成功");
      this.isDownLoading = false;
    },
    // 上划分页
    onUpRefreshLoad() {
      if (this.tab === "待认领心愿") {
        this.queryWishConfirmList();
      } else if (this.tab === "我的心愿") {
        this.queryWishList();
      } else if (this.tab === "已认领心愿") {
        this.queryClaimWish();
      }
    },
  },
};
</script>
<style lang="scss">
.private_btn {
  .van-badge {
    border: none;
  }
}
.wish {
  margin: 0 auto 0;
  width: 335px;
}
.mine {
  .register_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    letter-spacing: 0px;
    color: #e50012;
    text-align: center;
    width: 60px;
    height: 20px;
    background-color: #fff8d6;
    border-radius: 20px;
    margin-left: 6px;
  }
}
</style>
<style scoped lang="scss">
.index {
  position: relative;
  width: 100%;
  background-color: #b01f24;
  min-height: 100vh;
  padding-bottom: 10px;
}
// 机构样式
.organIndex {
  background-color: rgb(245, 245, 245);
  .header {
    padding-right: 17px;

    .header_avatar {
      .header_avatar_img {
        width: 51px;
        height: 51px;
        background-color: #a42a2a;
        border: solid 0px #fc703b;
      }
      .header_avatar_party {
        top: -2px;
        width: 15px;
        height: 16px;
        background-color: #e50012;
        border-radius: 50%;
      }
    }
    .header_btns {
      display: flex;
      align-items: center;
    }
    .header_infos {
      .header_names {
        span {
          font-size: 15px;
          font-weight: 600;
          line-height: 1;
          color: #ffffff;
        }
      }
      .header_adds {
        span {
          color: #fff;
        }
      }
    }
  }

  .tabs {
    background-color: transparent;
    box-shadow: 0 0 0 0 transparent;
    .tabs_header {
      color: rgba($color: #fefefe, $alpha: 0.6);
      /deep/.van-badge--fixed {
        border: none;
        top: -14px;
      }
      .active {
        color: #fffefe;
      }
      .tab1::after {
        color: #fffefe !important;
        background-color: #fffefe;
      }
      .active::before {
        color: #fffefe !important;
        background-color: #fffefe;
      }
    }
  }
}
.bg {
  z-index: 1;
  width: 100%;
  height: 185px;
  position: absolute;
  top: 0;
  left: 0;
}
.bg.bgjg {
  background-color: #1d62b8;
}
.header {
  position: relative;
  z-index: 10;
  padding: 17px;
  padding-right: 0;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  .header_avatar {
    position: relative;
    margin-right: 10px;
    .header_avatar_img {
      width: 50.5px;
      height: 50.5px;
      background-color: #a42a2a;
      border: solid 1px #fc703b;
      border-radius: 50%;
      object-fit: cover;
    }

    .header_avatar_party {
      position: absolute;
      right: -1px;
      top: -2px;
      width: 14px;
      height: 14px;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    }
  }
  .header_infos {
    display: flex;
    flex-direction: column;
    flex: 1;
    .header_names {
      display: flex;
      align-items: center;
      margin-bottom: 9px;
      span {
        font-size: 15px;
        font-weight: 800;
        color: #f9f1c6;
        margin-right: 4.5px;
        line-height: 1;
      }
      img {
        width: 11.5px;
        height: 11.5px;
      }
    }
    .header_adds {
      display: flex;
      align-items: center;
      img {
        width: 8.5px;
        height: 13px;
      }
      span {
        font-size: 12px;
        color: #f9f1c6;
        margin-left: 4.5px;
        line-height: 1;
      }
    }
  }
  .header_btns {
    .points {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 15px;
        margin-right: 4px;
      }
      span {
        font-size: 14px;
        color: #fefefe;
      }
    }
    .private_btn {
      position: relative;
      display: inline-flex;
      margin-left: 11.5px;
      img {
        width: 19px;
        height: 14px;
      }
      .red {
        position: absolute;
        right: -8px;
        top: -8px;
        min-width: 14px;
        height: 14px;
        background-color: #e50012;
        border-radius: 50%;
        color: #f9f1c6;
        font-size: 10px;
        padding: 2px;
        box-sizing: border-box;
        line-height: 14px;
      }
    }
    .login_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      letter-spacing: 0px;
      color: #e50012;
      text-align: center;
      width: 60px;
      height: 20px;
      background-color: #fff8d6;
      border-radius: 20px 0px 0px 20px;
    }
  }
}

.tabs {
  position: relative;
  z-index: 10;
  margin: 0 auto;
  width: 355px;
  min-height: calc(100vh - 165px);
  height: auto;
  background-color: #f9f1c6;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px 10px 0 0;
  .tabs_header {
    height: 46px;
    line-height: 46px;
    color: #333333;
    font-size: 15px;
    display: flex;
    align-items: center;
    .tab {
      position: relative;
      flex: 1;
      .tab_num {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 40px;
        top: 6px;
        min-width: 12px;
        height: 12px;
        line-height: 12px;
        background-color: #e50012;
        border-radius: 50%;
        color: #f9f1c6;
        font-size: 10px;
        padding: 2px;
        box-sizing: border-box;
      }
    }
    .active {
      position: relative;
      color: #e50012;
    }
    .active::before {
      content: "";
      position: absolute;
      bottom: 10px;
      left: 50%;
      margin-left: -11.5px;
      width: 23px;
      height: 1px;
      background-color: #e50012;
    }
    .tab1::after {
      content: "";
      position: absolute;
      right: 0;
      top: 18.5px;
      width: 1px;
      height: 10px;
      background-color: rgba(230, 0, 18, 0.5);
    }
  }

  .tabs_content {
    width: 335px;
    border-radius: 10px;
    margin: 0 auto 10px;
    padding-bottom: 10px;
    /deep/ .mywish {
      .btn_section {
        .btn {
          margin: 10px auto;
        }
      }
    }
  }
  /deep/ .van-pull-refresh {
    min-height: calc(100vh - 202px);
  }
}

/* 认领心愿 */
.gotWish {
  padding: 20px 0;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.contents_infos {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.list_avatar {
  margin-right: 9.5px;
  width: 30.5px;
  height: 30.5px;
}

.list_avatar img {
  width: 30.5px;
  height: 30.5px;
  border-radius: 50%;
}

.list_contents {
  width: 294px;
}

.list_infos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
}

.list_infos_left {
}

.list_name_section {
  display: inline-flex;
  align-items: center;
  margin-bottom: 5px;
}

.list_name {
  font-size: 15px;
  color: #333333;
}

.private_letter_btn {
  width: 15px;
  height: 11px;
  padding: 0 5px;
}

.help_btn {
  width: 87.5px;
  height: 15.5px;
  border-radius: 10px;
  border: solid 1px #e50012;
  font-size: 12px;
  line-height: 15.5px;
  color: #e50012;
  span-align: center;
}

.helped_btn img {
  width: 11.5px;
  height: 9.5px;
}

.list_address {
  font-size: 12px;
  color: #666666;
  line-height: 1;
  padding-bottom: 10px;
}

.list_infos_right {
  width: 13px;
}

.list_infos_right img {
  width: 13px;
  height: 16px;
}

/* 内容区 */
.list_des_section {
  position: relative;
  padding: 0 10px;
}

.list_des {
  font-size: 13px;
  color: #333333;
}

/* 图片区域 */
.imgs {
  width: 100%;
  margin-top: 14.5px;
}

.imgs img {
  width: 100%;
  border-radius: 10px;
}

/* 点赞评论关注区 */
.list_funs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px 10px 0;
}

.list_funs_time {
  font-size: 12px;
  color: #999999;
}

.list_funs_right {
  display: flex;
  align-items: center;
}

.list_funs_thumb {
  display: flex;
  align-items: center;
  padding-right: 12.5px;
}

.list_funs_thumb_img {
  width: 14px;
  height: 11px;
  vertical-align: middle;
}

.list_funs_thumb_span {
  font-size: 13px;
  color: #e50012;
  margin-left: 2px;
}

.small_line {
  width: 0.5px;
  height: 8.5px;
  background-color: #999999;
}

.comment_btn {
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.comment_img {
  width: 14px;
  height: 13px;
  vertical-align: middle;
}

.concern_btn {
  display: flex;
  align-items: center;
  padding-left: 9px;
}

.concern_img {
  width: 14.5px;
  height: 15px;
  vertical-align: middle;
}

.concern_span {
  font-size: 12px;
  color: #999999;
  margin-left: 2.5px;
}

/* 心愿详情进度 内容区 */
.progress_contents {
  width: 100%;
  position: relative;
}

.progress_header {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 15px 0 17.5px;
}

.progress_header_dot {
  width: 3px;
  height: 3px;
  background-color: #ff0000;
}

.progress_header_title {
  font-size: 15px;
  color: #e50012;
  padding: 0 5px;
}

/* 头部切换区 */
.progress_tabs {
  height: 45px;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: rgba(229, 0, 18, 0.1);
}

.progress_tabs_one {
  height: auto;
}

.progress_tabs_one .progress_tab {
  height: auto;
  background-color: transparent;
  padding: 15px 15px;
}

.progress_tabs_one .progress_name,
.progress_tabs_one .progress_tab_time {
  color: #e50012;
}

.progress_tab {
  display: flex;
  flex: 1;
  height: 45px;
  background-color: rgba(229, 0, 18, 0.3);
  border-radius: 10px 10px 0px 0px;
  padding: 10px 15px;
  box-sizing: border-box;
}

.progress_tab_imgs {
  position: relative;
}

.progress_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.progress_party {
  position: absolute;
  right: 0;
  top: 0;
  width: 11px;
  height: 11px;
}

.progress_titles {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.progress_name {
  font-size: 13px;
  color: #ffff7e;
}

.progress_tab_time {
  font-size: 10px;
  color: #ffff7e;
}

.progress_content {
  position: relative;
  overflow: hidden;
  background-color: rgba(290, 0, 18, 0.1);
  padding: 0 15px;
}

/* 进度条 */
.progress_lines {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 59.5px;
  top: -100rppx;
  align-items: center;
  z-index: 1;
}

.progress_lines img {
  position: absolute;
  top: 0;
  left: -11.5px;
  width: 9px;
  height: 8px;
}

.progress_line {
  position: absolute;
  top: 5px;
  left: -7.5px;
  width: 1.5px;
  height: 500px;
  background-color: #ff0000;
  z-index: 10;
}

.progress_content_item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.progress_content_item:last-child {
  margin-bottom: 0;
}

.progress_times {
  display: inline-flex;
  align-items: center;
  height: 33px;
}

.progress_time {
  font-size: 12px;
  color: #666666;
}

.progress_circle {
  width: 8.5px;
  height: 8.5px;
  margin-left: 7px;
  background-color: rgba(230, 0, 18, 0.1);
  border-radius: 50%;
  z-index: 10;
}

.progress_infos {
  position: relative;
  padding: 9px 12px;
  width: 250px;
  box-sizing: border-box;
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 10px;
}

.progress_infos::before {
  content: "";
  position: absolute;
  left: -21px;
  top: 12px;
  width: 7.5px;
  border-right: 15px solid rgba(255, 0, 0, 0.1);
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid transparent;
}

.progress_words {
  font-size: 14px;
  line-height: 1.4;
  color: #666666;
}

.progress_imgs {
  display: flex;
  margin-top: 9px;
}

.progress_imgs img {
  width: 48px;
  height: 48px;
  margin-right: 5px;
}

/* 查看更多进度 */
.more {
  position: absolute;
  bottom: 0;
  left: -15px;
  z-index: 100;
  width: 350px;
}

.more_bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: -1;
}

.more_span {
  font-size: 13px;
  color: #e50012;
  width: 100%;
  span-align: center;
  padding-bottom: 10px;
}

.more_span img {
  width: 9px;
  margin-left: 3px;
}

.progress_btn {
  position: relative;
  width: 130px;
  height: 30px;
  margin: 20px auto 0;
}

.progress_btn img {
  position: absolute;
  left: 0;
  top: 0;
  width: 130px;
  height: 30px;
  z-index: 1;
}

.progress_btn span {
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: 15px;
  line-height: 30px;
  color: #f9f1c6;
  span-align: center;
  z-index: 10;
}

/* 评论回复 */

.mine_comment {
  padding: 15px 10px;
  width: 100%;
  box-sizing: border-box;
}

.mine_comment_top {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.mine_comment_avatar {
  width: 30.5px;
  height: 30.5px;
  margin-right: 10px;
}

.mine_comment_avatar img {
  width: 30.5px;
  height: 30.5px;
}

.mine_comment_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mine_comment_info {
}

.mine_comment_name {
  font-size: 15px;
  color: #333333;
  margin-bottom: 6px;
  line-height: 1;
}

.mine_comment_time {
  font-size: 12px;
  color: #999999;
  line-height: 1;
}

.mine_comment_btns {
  display: flex;
  align-items: center;
}

.gray_line {
  width: 1px;
  height: 10px;
  background-color: #999999;
  margin: 0 10px;
}

.mine_comment_thumb_box {
  display: flex;
  align-items: center;
}

.mine_comment_thumb {
  width: 14px;
  height: 11px;
  margin-right: 5px;
}

.mine_comment_thumb_box span {
  font-size: 13px;
  color: #e50012;
}

.mine_comment_icon_box {
  display: flex;
  align-items: center;
}

.mine_comment_icon {
  width: 14px;
  height: 13px;
}

.mine_comment_icon_box span {
  font-size: 13px;
  color: #e50012;
}

.mine_comment_words {
  margin-left: 41.5px;
  margin-right: 10px;
}

.mine_comment_reply {
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #333333;
}

.mine_comment_ante {
  font-size: 13px;
  letter-spacing: 0.5px;
  color: #e50012;
}

.mine_comment_details {
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #333333;
}

/* 弹出层 */
.pop_content {
  width: 334px;
  height: 294px;
  background-color: #f9f1c6;
  border-radius: 10px;
}

.pop_header {
  font-size: 15px;
  color: #333333;
  width: 100%;
  span-align: center;
  padding: 20px 0;
}

.spanarea_section {
  position: relative;
  width: 294.5px;
  height: 170.5px;
  background-color: rgba(230, 0, 18, 0.1);
  border-radius: 10px;
  font-size: 13px;
  line-height: 1;
  color: #999999;
  overflow: hidden;
  margin: 0 auto 22px;
}

.spanarea_section .van-cell {
  background-color: transparent;
}

.spanarea_section .van-field__control {
  color: #666666 !important;
}

.spanarea_section_label {
  font-size: 15px;
  color: #333333;
}

.spanarea_section_nums {
  position: absolute;
  display: flex;
  right: 10px;
  bottom: 13.5px;
}

.spanarea_section_nums span {
  font-size: 11px;
  color: #999999;
}

.pop_btn {
  position: relative;
  width: 130px;
  height: 30px;
  margin: 0 auto;
}

.pop_btn img {
  width: 130px;
  height: 30px;
}

.pop_btn span {
  display: inline-block;
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  color: #ffffff;
  z-index: 1;
  left: 0;
  margin-bottom: 15px;
}
</style>
